import { grey } from "@material-ui/core/colors";

const styles = {
  navigation: {
    fontSize: 15,
    fontWeight: 300,
    color: grey[600],
    paddingBottom: 15,
    display: "block"
  },
  title: {
    fontSize: 24,
    fontWeight: 300,
    marginBottom: 20
  },
  paper: {
    padding: 30
  },
  clear: {
    clear: "both"
  }
};

export default styles;